<template>
  <div>
    <section class="section-header-info middle-content">
      <div class="container big-container">
        <div id="driver-tracker" class="driver-tracker-main">
          <div class="tracker-left-side">
            <div class="title-tracker-wrapper">
              <button
                type="button"
                class="btn-back-tracker"
                v-if="isDetail"
                @click="backToList()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="48"
                    d="M244 400L100 256l144-144"
                  ></path>
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="48"
                    d="M120 256h292"
                  ></path>
                </svg>
              </button>
              <h1 class="fleet-tracker-title">
                {{ isDetail ? "Driver Tracker" : "Fleet Tracker" }}
              </h1>
            </div>

            <div class="list-reservation" v-if="!isDetail">
              <div
                class="reservation-item"
                v-for="(item, index) in data"
                :key="index"
                @click="getById(item.reservationId)"
              >
                <div class="reservation-item-value">
                  <i
                    class="ic-flight-departure-icon"
                    v-if="item.serviceType === 1"
                  ></i>
                  <i
                    class="ic-flight-icon"
                    v-else-if="item.serviceType === 2"
                  ></i>
                  <i class="ic-car-alt" v-else-if="item.serviceType === 3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 1200 1200"
                    >
                      <path
                        fill="currentColor"
                        d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                      />
                    </svg>
                  </i>
                  <i class="ic-time" v-else-if="item.serviceType === 4"></i>
                  <div class="reservation-item-box">
                    <span class="reservation-item-code">{{
                      item.codeBooking
                    }}</span>
                    <!-- <span class="reservation-item-address">{{
                      item.pickUpName
                    }}</span> -->
                    <div class="reservation-item-pickuptime">
                      <span>Pick-up Location :</span>
                      <span> {{ item.pickUpName }}</span>
                    </div>
                    <div class="reservation-item-pickuptime">
                      <span>Pick-up Time :</span>
                      <span>
                        {{ $helper.timeFormatted(item.pickUpTime) }} ({{
                          item.pickUpTimeZone
                        }})</span
                      >
                    </div>
                    <div class="reservation-item-pickuptime">
                      <span>Driver Name :</span>
                      <span> {{ item.driverName }}</span>
                    </div>
                  </div>
                </div>
                <img
                  src="/static/assets/images/chevron-right.svg"
                  alt="chevron-right-image"
                />
              </div>

              <div class="vehicles-offline-wrapper" v-if="data.length === 0">
                <img
                  src="/static/assets/images/car-offline-green-with-close.svg"
                  width="70"
                  height="70"
                  alt="vehicle-offline-logo"
                />
                <p class="vehicles-ofline-text">
                  All vehicles are currently offline.
                </p>
              </div>
            </div>

            <div class="detail-reservation" v-else>
              <span class="reservation-code-number">{{
                detailData.codeBooking
              }}</span>

              <div class="driver-info">
                <div class="driver-value">
                  {{ `${driverData.title} ${driverData.fullName}` }}
                </div>
                <div class="driver-value">
                  {{ `+${driverData.phoneCode} ${driverData.phoneNumber}` }}
                </div>
                <div class="driver-value">
                  {{
                    `${vehicleData.plateNumber} (${vehicleData.brandName}${
                      vehicleData.feature.color
                        ? `${", " + vehicleData.feature.color}`
                        : ""
                    })`
                  }}
                </div>
              </div>

              <div class="reservation-logging-wrapper">
                <div class="trip-info">
                  <div v-for="(history, index) in histories" :key="index">
                    <div class="col-sm-12">
                      <div
                        :class="[
                          index === histories.length - 1
                            ? 'end-time-stamp'
                            : 'time-stamp',
                          history.event.toLowerCase().includes('dropped')
                            ? 'dropped'
                            : '',
                        ]"
                      >
                        <div class="stamp-status d-flex items-center --green">
                          <span>{{ $helper.humanize(history.eventText) }}</span>
                        </div>
                        <div class="stamp-desc">
                          {{ "User : " + history.createdBy }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tracker-right-side">
            <div id="map"></div>
            <div
              id="last__updated_id"
              class="last__updated__wrapper"
              v-if="isDetail && lastUpdated && distanceData"
            >
              <div class="duration__distance__box">
                <span class="duration__distance__value"
                  >Estimate
                  {{
                    detailData.lastStateEnum == 12
                      ? "to PU Point"
                      : "to DO Point"
                  }}: {{ distanceData.distanceText }}
                  <div class="utc">({{ `${distanceData.durationText}` }})</div>

                  <button
                    type="button"
                    class="btn-reload"
                    @click="reloadDistanceDuration()"
                  >
                    <i
                      class="ic-refresh refresh-icon"
                      style="font-size: 13px"
                    ></i>
                  </button>
                </span>
              </div>
              <div class="last__updated__box">
                <span class="indicator" :class="colorIndicator"></span>
                <span class="last__updated__value"
                  >Last updated: {{ lastUpdated.time }}
                  <div class="utc">({{ `UTC${lastUpdated.utc}` }})</div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import inquiryTenantJobService from "@/services/job/tenantJob/inquiryTenantJobService.js";
import mapsService from "@/services/maps/mapsService.js";
import { firebaseDB } from "@/plugins/firebase.js";
import maverickMap from "@/plugins/google/map.js";

export default {
  data() {
    return {
      data: [],
      detailData: {},
      calculateDistanceDurationStatus: false,
      distanceData: null,
      lastUpdated: null,
      driverData: {},
      vehicleData: {},
      pickUpLocation: {},
      dropOffLocation: {},
      histories: [],
      lastState: null,
      map: null,
      isDetail: false,
      hasFitMapOnce: false,
      reservationId: null,
      colorIndicator: "",
      isLoading: false,
      msg: "Please wait",
    };
  },
  async mounted() {
    this.map = new maverickMap({
      mapId: "map",
      lat: 1.29027,
      lng: 103.851959,
      marker: true,
      enableMarkerClick: false,
    });
    this.map.initialize();

    this.getListReservation();
  },
  methods: {
    async getListReservation() {
      this.isLoading = true;
      let getData = firebaseDB.ref("locations/");
      await getData.on("value", (snapshot) => {
        if (!this.isDetail) {
          this.data = [];
          this.map.clearMarkers();
          const data = snapshot.val();
          for (const [key, item] of Object.entries(data)) {
            const pickupTime = new Date(item.pickUpTime);
            const now = new Date();
            const diffMs = now.getTime() - pickupTime.getTime();
            const isMoreThan24Hours = diffMs >= 24 * 60 * 60 * 1000;

            if (
              item.lastStateEnum === 18 ||
              item.lastStateEnum === 20 ||
              isMoreThan24Hours
            ) {
              firebaseDB.ref("locations/" + key).remove();
            } else {
              this.data.push({
                reservationId: key,
                serviceType: item.subServiceType,
                codeBooking: item.codeBooking,
                latitude: item.latitude,
                longitude: item.longitude,
                pickUpName: item.pickUpName,
                dropOffName: item.dropOffName,
                pickUpTime: item.pickUpTime,
                pickUpTimeZone: item.pickUpTimeZone,
                driverName: item.driverName,
              });
            }
          }

          this.data = this.data.sort(
            (a, b) => new Date(a.pickUpTime) - new Date(b.pickUpTime)
          );

          this.data.forEach((val) => {
            const infoContent = `<strong>${val.driverName}</strong>`;
            this.map.addMarker(
              {
                lat: val.latitude,
                lng: val.longitude,
              },
              infoContent
            );
          });

          if (!this.hasFitMapOnce) {
            this.map.fitToMarkers();
            this.hasFitMapOnce = true;
          }
        }
      });

      this.isLoading = false;
    },
    reloadDistanceDuration() {
      this.calculateDistanceDurationStatus = false;
      this.getDetailReservation();
    },
    getDetailReservation() {
      let getDetail = firebaseDB.ref("locations/" + this.reservationId);
      getDetail.on("value", (snapshot) => {
        if (snapshot.val() === null) {
          this.backToList();
        }

        if (this.isDetail) {
          if (this.reservationId === snapshot.val().id) {
            this.map.clearMarkers();
            this.detailData = snapshot.val();

            const driverPoint = {
              lat: this.detailData.latitude,
              lng: this.detailData.longitude,
            };
            const destinationPoint = {
              lat:
                this.detailData.lastStateEnum === 12
                  ? this.pickUpLocation.latitude
                  : this.dropOffLocation.latitude,
              lng:
                this.detailData.lastStateEnum === 12
                  ? this.pickUpLocation.longitude
                  : this.dropOffLocation.longitude,
            };

            if (!this.calculateDistanceDurationStatus) {
              this.calculateDistanceDuration(driverPoint, destinationPoint);
              this.calculateDistanceDurationStatus = true;
            }

            // last updated
            const localDate = new Date();
            const date = new Date(this.detailData.timestamp * 1000);

            const diffSeconds = Math.floor((localDate - date) / 1000);

            if (diffSeconds < 30) {
              this.colorIndicator = "green-indicator";
            } else if (diffSeconds < 120) {
              this.colorIndicator = "yellow-indicator";
            } else if (diffSeconds < 300) {
              this.colorIndicator = "red-indicator";
            } else {
              this.colorIndicator = "grey-indicator";
            }

            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");

            const offset = new Date().getTimezoneOffset();
            const utcOffset = `${offset > 0 ? "-" : "+"}${String(
              Math.floor(Math.abs(offset) / 60)
            ).padStart(2, "0")}:${String(Math.abs(offset) % 60).padStart(
              2,
              "0"
            )}`;

            this.lastUpdated = {
              time: `${hours}:${minutes}:${seconds}`,
              utc: utcOffset,
            };
            // end last updated

            if (Object.keys(this.pickUpLocation).length !== 0) {
              const pickUpLocationCoor = {
                lat: this.pickUpLocation.latitude,
                lng: this.pickUpLocation.longitude,
                icon: "/static/assets/images/marker-pin-red.png",
              };
              this.map.addMarker(pickUpLocationCoor);
            }

            if (Object.keys(this.dropOffLocation).length !== 0) {
              const dropOffLocationCoor = {
                lat: this.dropOffLocation.latitude,
                lng: this.dropOffLocation.longitude,
                icon: "/static/assets/images/marker-pin-blue.png",
              };
              this.map.addMarker(dropOffLocationCoor);
            }

            this.map.addMarker({
              lat: this.detailData.latitude,
              lng: this.detailData.longitude,
            });

            this.map.setCenter({
              lat: this.detailData.latitude,
              lng: this.detailData.longitude,
            });

            if (!this.hasFitMapOnce) {
              // this.map.setZoom(16);
              this.map.fitToMarkers();
              this.hasFitMapOnce = true;
            }

            if (this.detailData.lastStateEnum != this.lastState) {
              this.lastState = this.detailData.lastStateEnum;
              this.getById(this.reservationId, false);
            }
          }
        }
      });
    },
    async getById(reservationId, loader = true) {
      if (loader) this.isLoading = true;
      try {
        const reservation = await inquiryTenantJobService.getDetail(
          reservationId
        );
        this.driverData = reservation.driver;
        this.vehicleData = reservation.vehicle;
        this.pickUpLocation = {
          latitude: reservation.pickUpLocation.latitude,
          longitude: reservation.pickUpLocation.longitude,
        };
        this.dropOffLocation = {
          latitude: reservation.dropOffLocation.latitude,
          longitude: reservation.dropOffLocation.longitude,
        };
        const historiesData = reservation.histories;

        const lastHistory = historiesData[historiesData.length - 1];

        if (lastHistory.eventEnum === 18 || lastHistory.eventEnum === 20) {
          this.backToList();
          firebaseDB.ref("locations/" + reservationId).remove();
        }

        const startIndex = historiesData.findIndex(
          (item) => item.eventText === "Driver enroute"
        );

        this.histories =
          startIndex !== -1 ? historiesData.slice(startIndex) : [];
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isDetail = true;
        this.isLoading = false;
        this.hasFitMapOnce = false;
        this.reservationId = reservationId;
        this.getDetailReservation();
      }
    },
    backToList() {
      this.hasFitMapOnce = false;
      this.isDetail = false;
      this.lastUpdated = null;
      this.detailData = {};
      this.driverData = {};
      this.vehicleData = {};
      this.histories = [];
      this.reservationId = null;
      this.map.clearMarkers();
      this.getListReservation();
    },
    async calculateDistanceDuration(driverPoint, dropOffPoint) {
      try {
        const query = `?originLat=${driverPoint.lat}&originLng=${driverPoint.lng}&destinationLat=${dropOffPoint.lat}&destinationLng=${dropOffPoint.lng}`;
        this.distanceData = await mapsService.getDistanceMatrix(query);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
  },
  updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("fleet-driver-tracker-link");
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/tracker/index.vue